"use strict";

var _defineProperty2 = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _Card = _interopRequireDefault(require("./Card"));
var _CountdownTimer = _interopRequireDefault(require("./CountdownTimer"));
require("./style/style.css");
var _LevelIndicator = _interopRequireDefault(require("./LevelIndicator"));
var _ScoreIndicator = _interopRequireDefault(require("./ScoreIndicator"));
var _EndgamePage = _interopRequireDefault(require("./EndgamePage"));
var _HighScoresPage = _interopRequireDefault(require("./HighScoresPage"));
var _reactCountdownCircleTimer = require("react-countdown-circle-timer");
var _Countdown = _interopRequireDefault(require("./Countdown"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MemoryGame = /*#__PURE__*/function (_react$default$Compon) {
  function MemoryGame() {
    var _this;
    _classCallCheck(this, MemoryGame);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MemoryGame, [].concat(args));
    _defineProperty(_this, "state", {
      started: false,
      preview: false,
      nbComplete: 0,
      cards: [],
      openedCards: [],
      finished: false,
      score: 0,
      levelStartup: false,
      showHighScores: false
    });
    return _this;
  }
  _inherits(MemoryGame, _react$default$Compon);
  return _createClass(MemoryGame, [{
    key: "handleClick",
    value: function handleClick(uri, index) {
      var _this2 = this;
      if (this.state.openedCards.length === 2) return;
      var card = {
        uri: uri,
        index: index
      };
      var cards = this.state.cards;
      var openedCards = this.state.openedCards;
      cards[index].close = false;
      openedCards.push(card);
      var state = {
        openedCards: openedCards,
        cards: cards
      };
      this.setState(state, function () {
        if (_this2.state.openedCards.length === 2) {
          setTimeout(function () {
            _this2.check();
          }, 750);
        }
      });
    }
  }, {
    key: "check",
    value: function check() {
      var _this$state = this.state,
        openedCards = _this$state.openedCards,
        startedAt = _this$state.startedAt,
        score = _this$state.score;
      if (openedCards.length !== 2) return;
      var _this$state2 = this.state,
        cards = _this$state2.cards,
        nbComplete = _this$state2.nbComplete;
      var self = this;
      var correct = false;
      if (openedCards[0].uri === openedCards[1].uri && openedCards[0].index !== openedCards[1].index) {
        cards[openedCards[0].index].complete = true;
        cards[openedCards[1].index].complete = true;
        correct = true;
      } else {
        cards[openedCards[0].index].close = true;
        cards[openedCards[1].index].close = true;
      }
      var win = false;
      var winTime = 0;
      if (correct) {
        nbComplete = nbComplete + 2;
        win = nbComplete === cards.length;
        if (win) {
          winTime = Date.now() - startedAt;
        }
      }
      this.setState(_objectSpread({
        cards: cards,
        openedCards: []
      }, correct ? {
        score: score + 60,
        nbComplete: nbComplete
      } : {
        score: Math.max(0, score - 30)
      }), function () {
        if (win) self.endGame(winTime);
      });
    }
  }, {
    key: "startGame",
    value: function startGame() {
      var cards = this.state.cards;
      var startedAt = Date.now();
      this.setState({
        started: true,
        preview: false,
        startedAt: startedAt,
        cards: cards.map(function (card) {
          return _objectSpread(_objectSpread({}, card), {}, {
            close: true
          });
        })
      });
    }
  }, {
    key: "start",
    value: function start(levelIdx) {
      var gameTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var levels = this.props.levels;
      var self = this;
      var level = levels[levelIdx];
      var cards = _lodash.default.sampleSize(this.props.cards, level.nbPairs);
      var duplicatedCards = cards.concat(cards);
      var randomizedCards = this.shuffle(duplicatedCards);
      var finalizedCards = randomizedCards.map(function (uri) {
        return {
          uri: uri,
          close: true,
          complete: false,
          fail: false
        };
      });
      this.setState({
        level: level,
        levelIdx: levelIdx,
        started: false,
        openedCards: [],
        preview: false,
        levelStartup: true,
        nbComplete: 0,
        cards: finalizedCards,
        finished: false,
        gameTime: gameTime
      }, function () {
        return setTimeout(function () {
          return self.setState({
            levelStartup: false,
            preview: true,
            cards: finalizedCards.map(function (c) {
              return _objectSpread(_objectSpread({}, c), {}, {
                close: false
              });
            })
          });
        }, 1500);
      });
    }
  }, {
    key: "shuffle",
    value: function shuffle(array) {
      var currentIndex = array.length,
        temporaryValue,
        randomIndex;
      while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }
      return array;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.start(0);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (!prevProps.cards && !!this.props.cards) {
        this.start(0);
      }
    }
  }, {
    key: "endGame",
    value: function endGame(levelTiming) {
      var levels = this.props.levels;
      var _this$state3 = this.state,
        levelIdx = _this$state3.levelIdx,
        gameTime = _this$state3.gameTime;
      var nextLevel = levelIdx + 1;
      if (nextLevel === levels.length) {
        this.setState({
          started: false,
          finished: true,
          gameTime: gameTime + levelTiming
        });
      } else {
        this.start(nextLevel, gameTime + levelTiming);
      }
    }
  }, {
    key: "onFormSubmit",
    value: function onFormSubmit(formData) {
      var _this$state4 = this.state,
        score = _this$state4.score,
        gameTime = _this$state4.gameTime;
      var submitScore = this.props.submitScore;
      var scoreObj = _objectSpread({
        score: score,
        gameTime: gameTime
      }, formData);
      submitScore(scoreObj);
      this.setState({
        showHighScores: true,
        currentScore: scoreObj
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state5 = this.state,
        level = _this$state5.level,
        started = _this$state5.started,
        score = _this$state5.score,
        preview = _this$state5.preview,
        finished = _this$state5.finished,
        levelStartup = _this$state5.levelStartup,
        gameTime = _this$state5.gameTime,
        showHighScores = _this$state5.showHighScores,
        currentScore = _this$state5.currentScore;
      var _this$props = this.props,
        cardsBack = _this$props.cardsBack,
        width = _this$props.width,
        fetchHighScores = _this$props.fetchHighScores;
      if (!level) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "memory-game"
      }, finished && !showHighScores && /*#__PURE__*/_react.default.createElement(_EndgamePage.default, {
        score: score,
        gameTime: gameTime,
        onSubmit: function onSubmit(formData) {
          return _this3.onFormSubmit(formData);
        }
      }), finished && showHighScores && /*#__PURE__*/_react.default.createElement(_HighScoresPage.default, {
        fetchHighScores: fetchHighScores,
        currentScore: currentScore,
        onReplayClick: function onReplayClick() {
          return _this3.setState({
            score: 0,
            showHighScores: false
          }, function () {
            return _this3.start(0);
          });
        }
      }), !finished && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, levelStartup && /*#__PURE__*/_react.default.createElement("div", {
        className: "level-start-container"
      }, /*#__PURE__*/_react.default.createElement(_LevelIndicator.default, {
        level: level.level,
        className: "level-start-label"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "game-header"
      }, /*#__PURE__*/_react.default.createElement(_LevelIndicator.default, {
        level: level.level
      }), preview && /*#__PURE__*/_react.default.createElement(_CountdownTimer.default, {
        size: width * 0.2,
        count: 4,
        delay: 800,
        onFinish: function onFinish() {
          return _this3.startGame();
        }
      }), started && /*#__PURE__*/_react.default.createElement(_reactCountdownCircleTimer.CountdownCircleTimer, {
        size: width * 0.2,
        isPlaying: started,
        renderTime: function renderTime(time) {
          return /*#__PURE__*/_react.default.createElement(_Countdown.default, {
            time: time
          });
        },
        durationSeconds: level.time,
        strokeWidth: width * 0.2 * 0.15,
        colors: [['#F7B801', .25], ['#FFAA00', .70], ['#d16057']],
        onComplete: function onComplete() {
          return _this3.endGame(level.time * 1000);
        }
      }), /*#__PURE__*/_react.default.createElement(_ScoreIndicator.default, {
        score: score
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "game-hint"
      }, "Trouve les doubles en ", level.time, "sec"), /*#__PURE__*/_react.default.createElement("div", {
        className: "playground",
        style: {
          width: level.width
        }
      }, this.state.cards.map(function (card, index) {
        return /*#__PURE__*/_react.default.createElement(_Card.default, {
          size: level.cardSize,
          key: index,
          back: cardsBack,
          card: card.uri,
          click: function click() {
            return started && !preview && _this3.handleClick(card.uri, index);
          },
          close: card.close,
          complete: card.complete
        });
      }))));
    }
  }]);
}(_react.default.Component);
var _default = exports.default = MemoryGame;